export default __webpack_public_path__ + "static/media/3.85a1ad7c.jpeg";